<!-- ======= Footer ======= -->
<footer id="footer">

  <!-- <div class="footer-newsletter" data-aos="fade-up">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-6">
          <h4>Join Our Newsletter</h4>
          <p>Tamen quem nulla quae legam multos aute sint culpa legam noster magna</p>
          <form action="" method="post">
            <input type="email" name="email"><input type="submit" value="Subscribe">
          </form>
        </div>
      </div>
    </div>
  </div> -->

  <div class="footer-top">
    <div class="container">
      <div class="row">

        <div class="col-lg-4 col-md-4 footer-contact" [attr.data-aos]="!isIEBrowser ? 'fade-up' : ''">
          <h3>Despre proiect</h3>
          <p [innerHTML]="aboutProject"></p>
        </div>

        <div class="col-lg-8 col-md-8 footer-links" [attr.data-aos]="!isIEBrowser ? 'fade-up' : ''" [attr.data-delay]="!isIEBrowser ? '200' : ''" *ngIf="utilLinks">
          <h3>Legături utile</h3>
          <div [innerHTML]="utilLinks"></div>
        </div>

      </div>
    </div>
  </div>

  <div class="container py-4">
    <div class="copyright">
      &copy; Copyright {{ year }} <a target="_blank" href="http://gamait.ro/">Gama IT</a>. Toate drepturile rezervate
    </div>
  </div>
</footer><!-- End Footer -->

<a href="#" class="back-to-top"><i class="icofont-simple-up"></i></a>
